import styles from './contractLoadingSkeleton.module.scss';

interface ContractLoadingSkeletonProps {
  isViewer: boolean;
}

export const ContractLoadingSkeleton = ({ isViewer }: ContractLoadingSkeletonProps) => (
  <div
    className={styles.contractLoadingSkeleton}
    data-testid='contract-loading-skeleton'
    aria-busy='true'
    aria-label='Loading project contract'
  >
    <div className={styles.heading} aria-hidden='true' />
    <div className={styles.boxes}>
      <div className={styles.contractBox}>
        <div className={styles.picture} aria-hidden='true' />
        <div className={styles.contractFields}>
          {Array.from({ length: 4 }, (_, index) => (
            <div key={index} className={styles.field} data-testid='contract-field-skeleton' aria-hidden='true'>
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.infoBoxes}>
        <div className={styles.infoRow}>
          <div className={styles.infoBox} data-testid='contract-info-skeleton' aria-hidden='true'>
            <span className={styles.infoPicture} />
            <span className={styles.label} />
            <span className={styles.value} />
          </div>
          {!isViewer && (
            <div className={styles.infoBox} data-testid='contract-info-skeleton' aria-hidden='true'>
              <span className={styles.infoPicture} />
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
          )}
        </div>
        <div className={styles.infoRow}>
          <div className={styles.infoBox} data-testid='contract-info-skeleton' aria-hidden='true'>
            <span className={styles.infoPicture} />
            <span className={styles.label} />
            <span className={styles.value} />
          </div>
        </div>
      </div>
    </div>
  </div>
);
